import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { useTheme } from 'styled-components';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { Loader } from '../Loader';
import { ClearIcon, Group, Wrapper } from './styled';
const TagComponent = memo(function TagComponent({ title, error, isLoading, isDisabled, isInactive, onClick, onDoubleClick, onRemove, dataTestId, }) {
    const { colors } = useTheme();
    const iconColor = useMemo(() => {
        if (error) {
            return isDisabled || isInactive ? colors.critical10_1 : colors.critical100;
        }
        return isDisabled || isInactive ? colors.grey30_1 : colors.grey100_1;
    }, [error, isDisabled, isInactive, colors.grey30_1, colors.grey100_1, colors.critical10_1, colors.critical100]);
    const handleRemove = useCallbackRef((e) => {
        e.stopPropagation();
        onRemove?.();
    });
    return (_jsxs(Wrapper, { error: error, isInactive: isInactive, isDisabled: isDisabled, onClick: !isDisabled ? onClick : undefined, onDoubleClick: !isDisabled ? onDoubleClick : undefined, "data-testid": dataTestId, children: [isLoading ? _jsx(Loader, { cover: true }) : null, title, onRemove && _jsx(ClearIcon, { size: 16, color: iconColor, onClick: !isDisabled ? handleRemove : undefined, isDisabled: isDisabled })] }));
});
export const Tag = Object.assign(TagComponent, {
    Group,
});
